import React from "react";
import Chip from "@material-ui/core/Chip";

// Readable text color (black/white) over a hex background.
export const contrastText = (hex) => {
  const value = String(hex || "").replace("#", "");
  if (value.length !== 6) return "#fff";
  const r = parseInt(value.slice(0, 2), 16);
  const g = parseInt(value.slice(2, 4), 16);
  const b = parseInt(value.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? "#111" : "#fff";
};

const TagChip = ({ tag, ...props }) => (
  <Chip
    size="small"
    label={tag.name}
    style={{
      backgroundColor: tag.color,
      color: contrastText(tag.color),
      marginRight: 4,
      marginBottom: 2,
    }}
    {...props}
  />
);

export default TagChip;
